import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { PairingEffects } from './pairing.effects';
import { pairingReducer } from './pairing.reducer';

export const providePairingStore = () => [provideState('pairing', pairingReducer), provideEffects([PairingEffects])];
